import LoadingComponent from '@/components/common/LoadingComponent';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { Sku12MonthHistoricalProps } from '@/types/props/components/skus';
import { SkuEnum } from '@/types/translations/SkuEnum';
import { toDe } from '@/utilites/sku-operations';

export default function Sku12MonthHistorical({
  lastActivitiesLoading,
  skuOrders,
  skuCurrentMarketValue,
  skuAverageSalePrice,
  skuTotalReturnPercentage,
  skuTotalReturn,
}: Sku12MonthHistoricalProps) {
  const { translate } = useTypedTranslation<SkuEnum>('sku');

  return (
    <div className="tw-my-10 tw-flex tw-flex-col nine:tw-basis-[35%]">
      <h2 className="pb-3 tw-relative tw-h-fit tw-text-2xl tw-font-semibold tw-text-textBlack max-nine:tw-hidden">
        {translate(SkuEnum['12_month_historical'])}
      </h2>
      <p className="tw-text-textblack tw-font-plusJakartaSans tw-text-base tw-font-medium nine:tw-hidden">
        <strong className="tw-font-plusJakartaSans tw-text-lg tw-font-semibold tw-text-text">
          {translate(SkuEnum['12_month_historical'])}
        </strong>
        <br />
      </p>
      <LoadingComponent
        as="div"
        componentProps={{
          className: 'tw-flex tw-flex-col tw-gap-3 tw-h-full child:tw-h-full',
        }}
        loading={lastActivitiesLoading}
      >
        <div className="tw-flex tw-items-center tw-gap-3 child:tw-h-full child:tw-basis-2/4 child:tw-px-4">
          <div className="tw-flex tw-flex-col tw-items-start tw-justify-center tw-rounded-lg tw-bg-[#F5F5F5] max-nine:tw-py-[15px]">
            <b className="tw-text-3xl tw-font-medium tw-text-text max-nine:tw-text-2xl max-nine:tw-leading-6">
              {skuOrders.length}
            </b>
            <p className="tw-m-0 tw-p-0 tw-font-medium tw-text-slate-gray max-nine:tw-leading-6">
              {translate(SkuEnum['value.number_of_sales'])}
            </p>
          </div>
          <div className="tw-flex tw-flex-col tw-items-start tw-justify-center tw-rounded-lg tw-bg-[#F5F5F5] max-nine:tw-py-[15px]">
            <b className="tw-text-3xl tw-font-medium tw-text-text max-nine:tw-text-2xl max-nine:tw-leading-6">
              €{toDe(skuCurrentMarketValue, { withSymbol: false })}
            </b>
            <p className="tw-m-0 tw-p-0 tw-font-medium tw-text-slate-gray max-nine:tw-leading-6">
              {translate(SkuEnum['value.market_value'])}
            </p>
          </div>
        </div>
        <div className="tw-flex tw-basis-full tw-flex-col tw-items-start tw-justify-center tw-rounded-lg tw-bg-[#F5F5F5] tw-px-4 max-nine:tw-py-[15px]">
          <b className="tw-text-3xl tw-font-medium tw-text-text max-nine:tw-text-2xl max-nine:tw-leading-6">
            €{toDe(skuAverageSalePrice, { withSymbol: false })}
          </b>
          <p className="tw-m-0 tw-p-0 tw-font-medium tw-text-slate-gray max-nine:tw-leading-6">
            {translate(SkuEnum['value.avg_sale_price'])}{' '}
          </p>
        </div>
        <div className="tw-flex tw-basis-full tw-flex-col tw-items-start tw-justify-center tw-rounded-lg tw-bg-[#F5F5F5] tw-px-4 max-nine:tw-py-[15px]">
          <b className="tw-text-3xl tw-font-medium tw-text-text max-nine:tw-text-2xl max-nine:tw-leading-6">
            €{toDe(skuTotalReturn, { withSymbol: false })}{' '}
            <span className="tw-font-medium tw-text-slate-gray max-nine:tw-leading-6">
              (
              {skuTotalReturnPercentage > 0
                ? `+${skuTotalReturnPercentage}`
                : skuTotalReturnPercentage === 0
                  ? skuTotalReturnPercentage
                  : `-${skuTotalReturnPercentage}`}
              %)
            </span>
          </b>
          <p className="tw-m-0 tw-p-0 tw-font-medium tw-text-slate-gray">
            {translate(SkuEnum['value.total_return'])}
          </p>
        </div>
      </LoadingComponent>
    </div>
  );
}
